import { Skills } from "./Skills";

export const Hero = () => {
    return (
        <section id="home" className="py-20 overflow-x-hidden">
            <div className="max-w-6xl mx-auto px-6">
                <div
                    className="flex flex-col-reverse md:flex-row items-center justify-between mt-8 md:space-x-12"
                    data-aos="fade"
                >
                    <div className="text-center md:text-left flex-1">
                        <h1 className="text-4xl text-stone-50">
                            Hey, I'm Rahul P Prabhu👋
                        </h1>

                        <h2 className="text-xl text-stone-50 mt-2">
                            Full Stack Developer | MERN Stack | Next.js | AI Integration
                        </h2>

                        <div className="mt-8 w-full flex justify-center md:justify-start">
                            <div className="w-[320px] md:w-[420px] overflow-hidden">
                                <Skills />
                            </div>
                        </div>

                    </div>

                    <div className="flex justify-center flex-1">
                        <img
                            src="/myimg.avif"
                            alt="mypic"
                            className="rounded-full w-56 h-56 object-cover"
                            data-aos="flip-up"
                            loading="eager"
                            fetchpriority="high"
                            decoding="sync"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};
